export const isHomepage = (pageId: string) => isBBHomepage(pageId) || isTvHomepage(pageId)

export const isBBHomepage = (pageId: string) => pageId === 'broadband'

export const isTvHomepage = (pageId: string) => pageId === 'tv'
